module.exports = __webpack_public_path__ + "static/media/vibino-feature-photo effect-PIC2.825c64ca.jpg";